export default {
  hasDashboard: false,
  isFixed: true,
  slug: "notification",
  display: false,
  menus: []
};